// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/rib/js/chatbot/assets/fonts/latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/rib/js/chatbot/assets/fonts/latin.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* latin-ext */
@font-face {
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

`, "",{"version":3,"sources":["/rib/js/chatbot/assets/fonts/noto-sans.css"],"names":[],"mappings":";AACA,cAAc;AACd;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD,gJAAgJ;AAClJ;AACA,UAAU;AACV;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAgD;EAChD,iMAAiM;AACnM","sourcesContent":["\n/* latin-ext */\n@font-face {\n  font-family: \"Noto Sans\";\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: 100%;\n  src: url(\"/rib/js/chatbot/assets/fonts/latin-ext.woff2\") format(\"woff2\");\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: \"Noto Sans\";\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: 100%;\n  src: url(\"/rib/js/chatbot/assets/fonts/latin.woff2\") format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
